
import Vue from 'vue';
import firebase from '@/plugins/firebase';
import { Project } from '@/types';
import { Prop, Component } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import Admin from '@/store/modules/admin';

@Component
export default class General extends Vue {
  adminModule = getModule(Admin, this.$store);
  snackbar = false;
  text = '保存しました';
  valid = true;

  get project() {
    return this.adminModule.project;
  }

  async save() {
    await this.adminModule.updateProject();
    this.snackbar = true;
  }
}
